<template>
  <div>
    <updateComponent class="ma-0"/>
  </div>
</template>

<script>
import updateComponent from '@/components/_managestructure/_update/update.vue'
export default {
  components: {
    updateComponent
  }
}
</script>
